export const testimonials = [
  {
    name: '林晓',
    role: '通勤党 · 每天地铁追更',
    text: '以前刷热点全靠各个平台乱翻，现在早上打开「今日上新」扫一遍就够了。按档期分栏这点特别贴心，周末想看什么一目了然。',
  },
  {
    name: '周予安',
    role: '剧集爱好者',
    text: '「本周推荐」的片单是我每周一固定的收藏动作。编辑会写清楚适合什么心情看，比单纯打个高分有用得多，很少踩雷。',
  },
  {
    name: '陈默',
    role: '内容创作者',
    text: '我最喜欢它的观察类文章，比如热梗是怎么发酵的。做选题时经常回来翻，思路很清晰，不像一般八卦号只堆情绪。',
  },
  {
    name: '苏晚',
    role: '长假旅行规划者',
    text: '「假日特辑」真的救过我的长假。追剧 marathon 那份配速表我照着执行了七天，最后居然没觉得累，还留出了出门散步的时间。',
  },
];